export default "__VITE_ASSET__BdJztzOw__"